import React, { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import SUG from "./shared/suggestions";

export default function PreferencesSection({ value = { domains: [], locations: [] }, onChange }) {
  const [domains, setDomains] = useState(value.domains || []);
  const [locations, setLocations] = useState(value.locations || []);
  const [open, setOpen] = useState(false);
  const [type, setType] = useState(""); // "domain" or "location"

  // Temporary modal state
  const [tempItems, setTempItems] = useState([]);
  const [input, setInput] = useState("");

  useEffect(() => {
    setDomains(value.domains || []);
    setLocations(value.locations || []);
  }, [value]);

  const openAdd = (t) => {
    setType(t);
    setTempItems([]);
    setInput("");
    setOpen(true);
  };

  // Add item to temporary list
  const addTempItem = (item) => {
    const trimmed = (item || input).trim();
    if (trimmed && !tempItems.includes(trimmed)) {
      setTempItems([...tempItems, trimmed]);
      setInput("");
    }
  };

  // Remove temp item
  const removeTemp = (i) => {
    setTempItems(tempItems.filter((_, idx) => idx !== i));
  };

  // Save all to main list
  const saveAll = () => {
    if (type === "domain") {
      const next = [...domains, ...tempItems];
      setDomains(next);
      onChange({ domains: next, locations });
    } else {
      const next = [...locations, ...tempItems];
      setLocations(next);
      onChange({ domains, locations: next });
    }
    setOpen(false);
    setTempItems([]);
    setInput("");
  };

  // Remove existing domain or location
  const remove = (t, i) => {
    if (t === "domain") {
      const next = domains.filter((_, idx) => idx !== i);
      setDomains(next);
      onChange({ domains: next, locations });
    } else {
      const next = locations.filter((_, idx) => idx !== i);
      setLocations(next);
      onChange({ domains, locations: next });
    }
  };

  // Suggestions (full match)
  const suggestions =
    type === "domain"
      ? SUG.domains.filter(
          (s) =>
            input &&
            s.toLowerCase().includes(input.toLowerCase()) &&
            !tempItems.includes(s)
        )
      : SUG.locations.filter(
          (s) =>
            input &&
            s.toLowerCase().includes(input.toLowerCase()) &&
            !tempItems.includes(s)
        );

  return (
    <section className="ccard">
      <div className="card-head">
        <h3>Preferences</h3>
      </div>

      <div className="card-body">

        {/* ---------- Domains Section ---------- */}
        <div className="sub-section">
          <div className="sub-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center"  }}>
            <h4 style={{paddingTop:"20px",paddingBottom:"15px"}}>Preferred Domains</h4>
            <button className="link" onClick={() => openAdd("domain")}>Add</button>
          </div>

          {domains.length === 0 ? (
            <p className="muted">No domains added</p>
          ) : (
            <div className="chips">
              {domains.map((d, i) => (
                <div className="chip" key={`d-${i}`}>
                  <span>{d}</span>
                  <MdClose className="x" onClick={() => remove("domain", i)} />
                </div>
              ))}
            </div>
          )}
        </div>

        {/* ---------- Locations Section ---------- */}
        <div className="sub-section">
          <div className="sub-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h4 style={{paddingTop:"20px",paddingBottom:"15px"}}>Preferred Locations</h4>
            <button className="link" onClick={() => openAdd("location")}>Add</button>
          </div>

          {locations.length === 0 ? (
            <p className="muted">No locations added</p>
          ) : (
            <div className="chips">
              {locations.map((l, i) => (
                <div className="chip" key={`l-${i}`}>
                  <span>{l}</span>
                  <MdClose className="x" onClick={() => remove("location", i)} />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* ---------- Modal for Adding Multiple ---------- */}
      {open && (
        <div className="modal-backdrop">
          <div className="modall-large">
            <div className="modal-head">
              <h3>
                {type === "domain" ? "Add Domains" : "Add Locations"}
              </h3>
              <button className="x" onClick={() => setOpen(false)}>✕</button>
            </div>

            <div className="modal-body">
              <div className="form-group autosuggest-wrapper">
                <label>
                  {type === "domain" ? "Type Domain" : "Type Location"}
                </label>
                <input
                  type="text"
                  value={input}
                  placeholder="Type and press Enter or click suggestion"
                  onChange={(e) => setInput(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), addTempItem())}
                />
                {suggestions.length > 0 && (
                  <ul className="suggestions-list">
                    {suggestions.map((s, idx) => (
                      <li key={idx} onClick={() => addTempItem(s)}>
                        {s}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {tempItems.length > 0 && (
                <div className="chips" style={{ marginTop: "10px" }}>
                  {tempItems.map((s, i) => (
                    <span key={i} className="chip">
                      {s}
                      <button className="x" onClick={() => removeTemp(i)}>×</button>
                    </span>
                  ))}
                </div>
              )}
            </div>

            <div className="modall-actions">
              <button className="btn secondary" onClick={() => setOpen(false)}>Cancel</button>
              <button className="btn" onClick={saveAll}>Save</button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
